import { render, staticRenderFns } from "./40loadRoad.vue?vue&type=template&id=0daede3c&scoped=true&"
import script from "./40loadRoad.vue?vue&type=script&lang=js&"
export * from "./40loadRoad.vue?vue&type=script&lang=js&"
import style0 from "./40loadRoad.vue?vue&type=style&index=0&id=0daede3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daede3c",
  null
  
)

export default component.exports